<template>
  <router-view/>

  <!-- Toast -->
  <div v-if="toast.show" class="toast-notification" :class="toast.type">
    <div class="toast-content">
      <span class="toast-message">{{ toast.message }}</span>
    </div>
  </div>

  <!-- Exit Confirm Popup -->
  <div v-if="exitConfirm.show" class="exit-modal">
    <div class="exit-box">
      <p class="exit-title">آیا می‌خواهید از برنامه خارج شوید؟</p>

      <div class="exit-actions">
        <button class="exit-btn yes" @click="confirmExit">بله</button>
        <button class="exit-btn no" @click="cancelExit">انصراف</button>
      </div>
    </div>
  </div>
</template>

<script>
import { App as CapApp } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'

export default {
  name: 'App',
  data() {
    return {
      toast: {
        show: false,
        message: '',
        type: 'info',
        timer: null
      },
      exitConfirm: {
        show: false
      }
    }
  },
  mounted() {
    const meta = document.createElement('meta')
    meta.name = 'viewport'
    meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
    document.getElementsByTagName('head')[0].appendChild(meta)

    window.addEventListener('app-notify', this.handleNotification)
    window.addEventListener('app-exit-request', this.showExitConfirm)
    window.addEventListener('app-back-pressed', this.onBackPressed)
  },
  beforeUnmount() {
    window.removeEventListener('app-notify', this.handleNotification)
    window.removeEventListener('app-exit-request', this.showExitConfirm)   // ✅ درست شد
    window.removeEventListener('app-back-pressed', this.onBackPressed)
  },
  methods: {
    handleNotification(event) {
      const { message, type } = event.detail
      this.showToast(message, type)
    },
    showToast(message, type = 'info') {
      if (this.toast.timer) clearTimeout(this.toast.timer)
      this.toast.message = message
      this.toast.type = type
      this.toast.show = true
      this.toast.timer = setTimeout(() => (this.toast.show = false), 3000)
    },

    showExitConfirm() {
      this.exitConfirm.show = true
    },

    async confirmExit() {
      this.exitConfirm.show = false

      // ✅ مهم: خروج واقعی نکن! فقط بفرست پس‌زمینه تا لاگین/لوکال نپره
      try {
        if (Capacitor.getPlatform() === 'android' && CapApp.minimizeApp) {
          await CapApp.exitApp() // ✅ خروج واقعی
        } else {
          // fallback (وب / پلتفرم‌های دیگه)
          // در وب کاری نمی‌کنیم
        }
      } catch (e) {
        console.log('minimizeApp not available:', e)
      }
    },

    cancelExit() {
      this.exitConfirm.show = false
    },

    onBackPressed(event) {
      // اگر مودال خروج بازه => با Back ببندش و جلوی ادامه رو بگیر
      if (this.exitConfirm.show) {
        this.exitConfirm.show = false
        event.preventDefault()
        return
      }

      // اگر Toast بازه => با Back ببندش و جلوی ادامه رو بگیر
      if (this.toast.show) {
        this.toast.show = false
        if (this.toast.timer) clearTimeout(this.toast.timer)
        event.preventDefault()
        return
      }
    }
  },
  watch: {
    $route() {
      window.scrollTo(0, 0)
      const main = document.getElementById('main')
      if (main) main.scrollTop = 0
    }
  }
}
</script>

<style>
@import './assets/styles/bootstrap.min.css';
@import './assets/styles/main.css';

html, body {
  touch-action: manipulation;
  -ms-touch-action: manipulation;
  overscroll-behavior-y: none;
}

/* Toast */
.toast-notification {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  min-width: 300px;
  max-width: 90%;
  padding: 1rem;
  border-radius: 50px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: slideDown 0.3s ease-out;
  font-weight: bold;
  font-size: 0.9rem;
}

.toast-notification.info {
  background-color: #333;
  color: white;
}

.toast-notification.success {
  background-color: #4CAF50;
  color: white;
}

.toast-notification.error {
  background-color: #F44336;
  color: white;
}

@keyframes slideDown {
  from { top: -50px; opacity: 0; }
  to { top: 20px; opacity: 1; }
}

/* Exit Modal */
.exit-modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exit-box {
  width: 92%;
  max-width: 360px;
  background: #fff;
  border-radius: 18px;
  padding: 18px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
  text-align: center;
}

.exit-title {
  margin: 0;
  font-weight: 800;
  font-size: 1rem;
}

.exit-actions {
  margin-top: 18px;
  display: flex;
  gap: 10px;
  justify-content: space-between;
}

.exit-btn {
  width: 100%;
  border: 0;
  border-radius: 12px;
  padding: 10px 12px;
  font-weight: 800;
}

.exit-btn.yes {
  background: #F44336;
  color: #fff;
}

.exit-btn.no {
  background: #e9e9e9;
  color: #333;
}
</style>
